import { useIntl, type WalletCustody } from '@capsicum/common';
import { useMyNfts, useMyOngoingParticipationsNfts } from '@capsicum/socios-core';

export const useNftLists = (walletCustody: WalletCustody) => {
	const { $t } = useIntl();

	const {
		data: { favoriteNfts, nfts } = { favoriteNfts: [], nfts: [] },
		error: nftErrors,
		isLoading: isLoadingNfts
	} = useMyNfts(walletCustody);
	const {
		data: { favorite: favoriteParticipationNfts, other: otherParticiapationNfts } = {
			favorite: [],
			other: []
		},
		error: ongoingParticipationErrors,
		isLoading: isLoadingParticipations
	} = useMyOngoingParticipationsNfts();

	const texts = {
		emptyList: $t('wallet.digitalCollectibles.emptyList'),
		favouriteTeamsTitle: $t('wallet.digitalCollectibles.favouriteTeamTitle'),
		goatAlt: $t('wallet.digitalCollectibles.goatAlt'),
		other: $t('global.other'),
		otherTeamsTitle: $t('wallet.digitalCollectibles.otherTeamsTitle'),
		title: $t('wallet.digitalCollectibles.pageTitle')
	};

	return {
		errors: [nftErrors, ongoingParticipationErrors],
		favoriteNfts: [...favoriteParticipationNfts, ...favoriteNfts],
		isLoading: isLoadingNfts || isLoadingParticipations,
		otherNfts: [...otherParticiapationNfts, ...nfts],
		texts
	};
};
